import { jsPDF } from 'jspdf';
import { MAT, TYPES, UPPERS, SLOTS, FACADES } from './catalog';

export async function svgToJpeg(svg, vb, pxW = 1800) {
  const clone = svg.cloneNode(true);
  const h = Math.round(pxW * (vb[3] / vb[2]));
  clone.setAttribute('width', pxW);
  clone.setAttribute('height', h);
  clone.removeAttribute('style');
  clone.removeAttribute('class');
  const str = new XMLSerializer().serializeToString(clone);
  const img = new Image();
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(str)}`; });
  const cv = document.createElement('canvas');
  cv.width = pxW; cv.height = h;
  const ctx = cv.getContext('2d');
  ctx.fillStyle = '#f6f1e8';
  ctx.fillRect(0, 0, pxW, h);
  ctx.drawImage(img, 0, 0, pxW, h);
  return { data: cv.toDataURL('image/jpeg', 0.82), ratio: h / pxW };
}

export function summaryLines(cfg, L) {
  const lines = [`Espace : ${Math.round(L.W / 10)} x ${Math.round(L.D / 10)} cm, hauteur ${Math.round(L.H / 10)} cm`];
  if (L.layout !== 'I') lines.push(`Implantation en ${L.layout} (${L.walls.length} murs)`);
  L.all.forEach((it) => {
    lines.push(`${it.idx + 1}. ${L.layout !== 'I' ? `[Mur ${it.wall}] ` : ''}${TYPES[it.type].label} - ${Math.round(it.w / 10)} cm${it.up ? ` + ${UPPERS[it.upper].label}` : ''}`);
  });
  if (L.island) lines.push(`${L.cat.island.label} - ${Math.round(L.island.w / 10)} x ${Math.round(L.island.d / 10)} cm`);
  return lines;
}

export function materialLines(cfg) {
  const fc = FACADES[cfg.facade] || FACADES.lisse;
  return [`Collection de façades : ${fc.label} (${fc.sub.toLowerCase()})`].concat(SLOTS.map((s) => `${s.label} : ${cfg.mats[s.id] === 'same' ? 'Identique aux façades' : MAT[cfg.mats[s.id]]?.label}`)
    .concat([`Éclairage LED intégré : ${cfg.led ? 'oui' : 'non'}`]));
}

const GOLD = [166, 137, 102];

function cartouche(doc, title, ref, date) {
  doc.setDrawColor(...GOLD); doc.setLineWidth(0.4); doc.line(10, 192, 287, 192);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(26, 26, 26);
  doc.text('JENMA CONCEPT', 10, 199);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(110, 100, 90);
  doc.text("Bureau d'agencement d'intérieur haut de gamme", 10, 204);
  doc.setFontSize(10); doc.setTextColor(26, 26, 26);
  doc.text(title, 148, 199, { align: 'center' });
  doc.setFontSize(8); doc.setTextColor(110, 100, 90);
  doc.text('Esquisse indicative non contractuelle - cotes en cm', 148, 204, { align: 'center' });
  doc.text(`Réf. ${ref}`, 287, 199, { align: 'right' });
  doc.text(date, 287, 204, { align: 'right' });
}

export async function buildPdf({ cfg, L, images, ref }) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const date = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  doc.setFillColor(26, 26, 26); doc.rect(0, 0, 297, 210, 'F');
  doc.setTextColor(...GOLD); doc.setFont('times', 'bold'); doc.setFontSize(34); doc.text('JENMA', 14, 28);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(170, 170, 170); doc.text('C O N C E P T', 15, 34);
  doc.setFillColor(77, 255, 184); doc.rect(14, 40, 12, 0.6, 'F');
  doc.setTextColor(245, 245, 245); doc.setFont('times', 'italic'); doc.setFontSize(20);
  doc.text("Étude d'agencement", 14, 54);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(13); doc.setTextColor(...GOLD); doc.text(L.cat.label, 14, 62);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(160, 160, 160); doc.text(`Réf. ${ref}  -  ${date}`, 14, 68);
  let y = 80;
  const block = (title, lines) => {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.setTextColor(...GOLD); doc.text(title.toUpperCase(), 14, y); y += 5;
    doc.setFont('helvetica', 'normal'); doc.setFontSize(7.6); doc.setTextColor(225, 225, 225);
    lines.forEach((l) => { doc.text(doc.splitTextToSize(l, 92), 14, y); y += 4.3; });
    y += 4;
  };
  block('Composition', summaryLines(cfg, L));
  block('Matériaux & finitions', materialLines(cfg));
  const pimg = images.perspective || images.plan;
  const pw = 176, ph = Math.min(170, pw * pimg.ratio);
  doc.setFillColor(246, 241, 232); doc.rect(112, 20, pw + 6, ph + 6, 'F');
  doc.addImage(pimg.data, 'JPEG', 115, 23, pw, ph);
  doc.setFontSize(7); doc.setTextColor(140, 140, 140); doc.text('www.jenmaconcept.com', 287, 204, { align: 'right' });
  [['plan', 'Plan de dessus'], ['elevation', L.layout === 'I' ? 'Élévation - mur principal' : 'Élévation - mur A'], ['elevationB', 'Élévation - mur B'], ['elevationC', 'Élévation - mur C'], ['perspective', 'Perspective 3D']].forEach(([k, t]) => {
    if (!images[k]) return;
    doc.addPage();
    doc.setFillColor(246, 241, 232); doc.rect(0, 0, 297, 210, 'F');
    const im = images[k];
    let w = 277, h = w * im.ratio;
    if (h > 176) { h = 176; w = h / im.ratio; }
    doc.addImage(im.data, 'JPEG', (297 - w) / 2, 10, w, h);
    cartouche(doc, t, ref, date);
  });
  return doc;
}
